import toast from 'react-hot-toast'
import create, { SetState, GetState } from 'zustand'
import { Axios, handleAxiosError } from '../utils'

type UtilState = {
  state?: any
  loading?: boolean
  fetchAvailablePolicies: () => void
}

const UtilStore = (set: SetState<UtilState>, get: GetState<UtilState>) => ({
  fetchAvailablePolicies: async () => {
    set({ loading: true })
    try {
      const { data } = await Axios.get('/util/policy-types')
      set({ loading: false, state: data.data.types.map((item: any) => item.slug) })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  }
})

const useUtilStore = create<UtilState>(UtilStore)
export default useUtilStore
